import { render, staticRenderFns } from "./SendedDetails.vue?vue&type=template&id=73afa6c4&scoped=true"
import script from "./SendedDetails.vue?vue&type=script&lang=js"
export * from "./SendedDetails.vue?vue&type=script&lang=js"
import style0 from "./SendedDetails.vue?vue&type=style&index=0&id=73afa6c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73afa6c4",
  null
  
)

export default component.exports